const API_BASE = process.env.REACT_APP_API_BASE || 'https://laforgeataches.fr/go/php';
const DEMO_MODE = process.env.REACT_APP_LAFORGE_DEMO === '1';

function buildUrl(path, query = '') {
  const normalized = `${API_BASE}${path}`;
  if (!DEMO_MODE) return `${normalized}${query}`;
  const separator = query.includes('?') ? '&' : '?';
  return `${normalized}${query}${separator}demo=1`;
}

export async function httpGet(path, query = '') {
  const response = await fetch(buildUrl(path, query), {
    credentials: 'include',
    headers: DEMO_MODE ? { 'X-Laforge-Demo': '1' } : undefined,
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  return response.json();
}

export async function httpPost(path, payload) {
  const response = await fetch(buildUrl(path), {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(DEMO_MODE ? { 'X-Laforge-Demo': '1' } : {}),
    },
    body: JSON.stringify(payload ?? {}),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `HTTP ${response.status}`);
  }

  return response.json();
}
